// ============================================================
// AN OBJECT'S OWN BOX (2026-10-26): the solid an Object that counts as terrain stands in (engine/objects/objectSolids),
// and the rule every check about its own place obeys - a thing is not behind itself: its overlap note and its own drag
// skip the box it is; everyone else meets it like any wall. Sight and cover to it need no skip: a measurement ignores
// a solid that contains its target's end (measureBetween), which its own box always does.
//
// Pure. Zero React dependency. Here, below `objects/`, so the battlefield can ask without an import cycle.
// ============================================================
import type { Solid } from './types';

/** The id an Object's box carries: one per object, so its own checks can find it and skip it. */
export const objectSolidId = (combatantId: string) => `obj-${combatantId}`;

/** The solids with this token's own box taken out (the same array when it has none): no one is behind himself. */
export function withoutOwnBox(solids: Solid[], tokenId: string): Solid[] {
  const own = objectSolidId(tokenId);
  return solids.some((s) => s.id === own) ? solids.filter((s) => s.id !== own) : solids;
}
